import { render } from "./DesktopAppShell.vue?vue&type=template&id=126c0e30"
import script from "./DesktopAppShell.vue?vue&type=script&lang=js"
export * from "./DesktopAppShell.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__